import { UpdateSecondHandSupplyService } from './../../services/update-second-hand-supply.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.scss']
})
export class RejectComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  rejectionForm = this.fb.group({
    status: ['REJECTED',[Validators.required]],
    rejection_reason: [null, [Validators.required]]
  });
/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private fb:FormBuilder,
    private dialogRef: MatDialogRef<RejectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    private updateSecondHandSupplyService: UpdateSecondHandSupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  async updateSecondHandSupply(){
    if(this.rejectionForm.invalid){
      this.toast.openSnackBar('Please enter rejection reason');
      return;
    }
    const rejectData = this.rejectionForm.value as any;
    try {
      await this.updateSecondHandSupplyService.updateSecondHandSupplyByPk(this.data.id, rejectData)
      this.toast.openSnackBar("Pre owned supply is rejected successfully");
      this.closeDialog('yes');
    } catch(error){
      this.toast.openSnackBar("Unable to reject pre owned supply");
    }
  }

  get rejection_reason(){
    return this.rejectionForm.get('rejection_reason');
  }
}



